import { UserSettingsService } from "common/services";
import { MrbBaseRouteStore } from "mrb/core";

class UserProfileEditRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = this.rootStore.application.baasic.membershipModule.user;
        this.userSettingsService = this.rootStore.createApplicationService(UserSettingsService);
    }

    getResource() {
        return Promise.resolve(this.rootStore.userStore.user);
    }

    update(resource) {
        return this.rootStore.userStore.updateAccountInfo(resource);
    }

    changeUserPassword(userId, resource) {
        return this.service.changePassword(userId, resource);
    }

    async getCertifiedModes() {
        const response = await this.userSettingsService.getCertifiedMode();
        return response.data;
    }

    async updateCertifiedMode(certifiedModeId, whitelistMode) {
        const response = await this.userSettingsService.updateCertifiedMode(certifiedModeId, whitelistMode);
        return response.data;
    }
}

export default UserProfileEditRouteStore;
